import React, { useEffect } from 'react';
import { Box } from '@neshane/blueberry';
import { Pagination } from '../../../../common/components';
import { usePagination } from '../../../../common/hooks/usePagination';
import { OperationsTable } from '../OperationsTable/OperationsTable';

export function OperationsPaginatedTable({ operations, filteredOperations, total, onRetry, onCancel, busyId }) {
    const data = filteredOperations ?? operations ?? [];
    const {
        paginatedItems,
        currentPage,
        totalPages,
        totalItems,
        goToPage,
        pageSize,
    } = usePagination(data, 10);

    useEffect(() => {
        if (currentPage > totalPages && totalPages > 0) goToPage(1);
    }, [currentPage, totalPages, goToPage]);

    return (
        <Box className="flex flex-col gap-16">
            <OperationsTable
                operations={operations}
                filteredOperations={paginatedItems}
                total={total}
                onRetry={onRetry}
                onCancel={onCancel}
                busyId={busyId}
            />
            {totalPages > 1 && (
                <Pagination
                    currentPage={currentPage}
                    totalPages={totalPages}
                    onPageChange={goToPage}
                    itemsPerPage={pageSize}
                    totalItems={totalItems}
                />
            )}
        </Box>
    );
}

export default OperationsPaginatedTable;
